module.exports = __webpack_public_path__ + "static/media/Public_06.c73a5d2e.jpg";